import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { useBreakpoints } from 'hooks/useBreakpoints';
import { TextV2 } from '../TextV2/TextV2';
import styles from './InvalidLeadPage.module.scss';

export const InvalidLeadPage: React.FC = () => {
  const { t } = useTranslation();
  const { browser } = useBreakpoints();
  const isDesktopOrLarge = browser.is.desktop;

  return (
    <>
      <h1>{t('lead-error.title')}</h1>
      <TextV2 isMarkdown value={t('lead-error.body-title')} className={styles.leadErrorPage} />
      <TextV2 isMarkdown value={t('lead-error.body-option-1')} className={styles.errorBody} />
      <TextV2
        isMarkdown
        value={isDesktopOrLarge ? t('lead-error.body-option-2') : t('lead-error.body-mobile-option-2')}
        className={styles.errorBody}
      />
    </>
  );
};
